// extracted by mini-css-extract-plugin
export default {"page_title":"Blog_page_title__q+IKm","container":"Blog_container__Yc1j0","blogList":"Blog_blogList__N2KXR","blogSummary":"Blog_blogSummary__v0rQP"};